import React, { useEffect } from 'react'
import SelectInput from '../inputs/select-input'
import TextInput from '../inputs/text-input'
import DateInput from '../inputs/date-input'
import DatePicker from 'react-datepicker'

const DateMatch = ({data, types, columns, onRemove, onChange, onTransform}) => {
  const conditions = [['between', 'is'], ['not between', 'is not'], ['<', 'is before'], ['>', 'is after']]
  const simpleValues = [
    [moment().format('MM/DD/YYYY'), 'today'],
    [moment().add(-1, 'day').format('MM/DD/YYYY'), 'yesterday'],
    [moment().add(1, 'day').format('MM/DD/YYYY'), 'tomorrow'],
    [moment().add(-7, 'days').format('MM/DD/YYYY'), 'week ago'],
    [moment().add(7, 'days').format('MM/DD/YYYY'), 'week from now'],
    [moment().add(-1, 'month').format('MM/DD/YYYY'), 'month ago'],
    [moment().add(1, 'month').format('MM/DD/YYYY'), 'month from now']
  ]
  const complexValues = ['N days ago', 'N days from now', 'exact date']
  const values = [...simpleValues, ...complexValues]
  const shortForm = !complexValues.includes(data.value || values[0][0])

  const resultDate = (params) => {
    if (!complexValues.includes(params.value)) return params.value
    if (params.value == 'exact date') return params.extra
    if (params.value == 'N days from now')
      return moment().add(params.extra, 'days').format('MM/DD/YYYY')
    else
      return moment().add(-params.extra, 'days').format('MM/DD/YYYY')
  }

  const resultValue = (params) => {
    const date = resultDate(params)

    if (['between', 'not between'].includes(params.condition)) {
      const startTime = moment(date).add(6, 'hours').format('MM/DD/YYYY hh:mm')
      const endTime = moment(date).add(30, 'hours').format('MM/DD/YYYY hh:mm')
      return `'${startTime}' and '${endTime}'`
    }
    if (params.condition == '<') return `'${moment(date).add(6, 'hours').format('MM/DD/YYYY hh:mm')}'`
    if (params.condition == '>') return `'${moment(date).add(30, 'hours').format('MM/DD/YYYY hh:mm')}'`
  }

  const query = (params) => {
    const value = resultValue(params)

    return `${params.column} ${params.condition} ${value}`
  }

  useEffect(() => {
    if (!data.condition) {
      const defaultParam = {...data, condition: conditions[0][0], value: values[0][0], completed: true}
      const defaultQuery = query(defaultParam)
      onChange({...defaultParam, query: defaultQuery})
    }
  }, [data.column])

  const isCompleted = (params) => {
    if (!complexValues.includes(params.value)) return true
    if (params.value != 'exact date') return true
    return !isNaN(new Date(params.extra))
  }

  const changeValue = (value) => {
    var extraValue = undefined
    if (value == 'N days ago' || value == 'N days from now') extraValue = 0
    if (value == 'exact date') extraValue = moment().format('MM/DD/YYYY')
    changeData({value: value, extra: extraValue})
  }

  const changeData = (params) => {
    const newData = {...data, ...params, completed: false, query: undefined}
    if (isCompleted(newData)) {
      newData.completed = true
      newData.query = query(newData)
    }
    onChange({...data, ...newData})
  }

  return <div className='filter-row'>
    { !data.type && <span className='where'>Where</span> }
    { data.type && 
      <SelectInput
        name='type'
        options={types}
        value={data.type}
        onChange={e => changeData({type: e.target.value})}
      />      
    }
    <SelectInput
      name='column'
      options={columns}
      value={data.column}
      onChange={e => onTransform(e.target.value)}
    />
    <SelectInput
      name='condition'
      options={conditions}
      value={data.condition || conditions[0][0]}
      onChange={e => changeData({condition: e.target.value})}
    />
    <SelectInput
      name='value'
      options={values}
      value={data.value || values[0][0]}
      onChange={e => changeValue(e.target.value)}
    />
    { !shortForm && data.value == 'exact date' &&
      <DatePicker
        dateFormat='MM/DD/YYYY'
        customInput={<DateInput />}
        onChange={date => changeData({extra: (date || moment()).format('MM/DD/YYYY')})}
        selected={moment(data.extra)}
      />
    }
    { !shortForm && data.value != 'exact date' &&
      <TextInput
        name='extra'
        type='number'
        step='1'
        min='0'
        max='10000'
        value={data.extra || 0}
        onChange={e => changeData({extra: e.target.value})}
      />
    }
    <button className='remove' onClick={onRemove}><i className='fa fa-trash-o' /></button>
  </div>
}

export default DateMatch
